import { render, staticRenderFns } from "./OtherTaxFilter.vue?vue&type=template&id=57add7de&scoped=true"
import script from "./OtherTaxFilter.vue?vue&type=script&lang=js"
export * from "./OtherTaxFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57add7de",
  null
  
)

export default component.exports